import { FC, Fragment } from 'react'
import { useFormContext } from 'react-hook-form'
import EXTRA_QUESTION_LABELS from '../../../../constants/extraQuestions'
import CheckboxGroupField from '../../../../shared/components/CheckboxGroupField'
import ControlledSelect from '../../../shared/ControlledSelect'
import HiddenFieldMirror from '../../../shared/HiddenFieldMirror'
import TextInputError from '../../../shared/TextInputError'

const JOB_COUNT_OPTIONS = [
  { label: '0', value: '0' },
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4+', value: '4+' },
]

const ADDITIONAL_INCOME_OPTIONS = [
  { label: 'Freelance or gig work', value: 'freelance' },
  { label: 'Side business or self-employment', value: 'side_business' },
  { label: 'None of the above', value: 'none' },
]

const JobCountAndIncome: FC = () => {
  const {
    register,
    formState: {
      errors: { jobCount: jobCountError, additionalIncomeSources: additionalIncomeSourcesError },
    },
    clearErrors,
  } = useFormContext()

  return (
    <Fragment>
      <HiddenFieldMirror name="jobCount" />
      <HiddenFieldMirror name="additionalIncomeSources" />
      <div className="col-span-full md:col-span-3">
        <ControlledSelect
          id="job-count-select"
          name="jobCount"
          label={EXTRA_QUESTION_LABELS.jobCount}
          options={JOB_COUNT_OPTIONS}
          error={typeof jobCountError?.message === 'string'}
          errorId="jobCount-error"
          registerOptions={{
            onChange: () => {
              if (jobCountError) clearErrors('jobCount')
            },
          }}
        />
        {typeof jobCountError?.message === 'string' && (
          <TextInputError id="jobCount-error">This field is required</TextInputError>
        )}
      </div>
      <div className="col-span-full md:col-span-3">
        <CheckboxGroupField
          name="additionalIncomeSources"
          label={EXTRA_QUESTION_LABELS.additionalIncomeSources}
          options={ADDITIONAL_INCOME_OPTIONS}
          hasError={typeof additionalIncomeSourcesError?.message === 'string'}
          errorId="additionalIncomeSources-error"
          inputProps={register('additionalIncomeSources')}
        />
        {typeof additionalIncomeSourcesError?.message === 'string' && (
          <TextInputError id="additionalIncomeSources-error">This field is required</TextInputError>
        )}
      </div>
    </Fragment>
  )
}

export default JobCountAndIncome
